import { render, staticRenderFns } from "./botaoSalvar.vue?vue&type=template&id=4fbb095a&scoped=true"
import script from "./botaoSalvar.vue?vue&type=script&lang=ts"
export * from "./botaoSalvar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb095a",
  null
  
)

export default component.exports